import React, { useEffect } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";

const navLinks = [
  { label: "Home", href: "/" },
  { label: "Literary", href: "/literary" },
  { label: "Excerpts", href: "/excerpts" },
  { label: "Authors", href: "/authors" },
  { label: "About Us", href: "/about-us" },
];

export const MyNavbar = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <Navbar
      expand="lg"
      className="my-3"
      data-aos="fade-down"
      style={{
        background: "rgba(246,246,246,0.94)",
        borderRadius: "12px",
        border: "1px solid #fff",
        boxShadow:
          "0px 1px 2px rgba(28,28,28,0.03), 0px 10px 10px rgba(28,28,28,0.12)",
        // margin: "0 2rem",
      }}
    >
      <Container
        fluid
        className="px-3 px-lg-4"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        {/* Brand */}
        <Navbar.Brand href="/" className="d-flex align-items-center gap-2">
          <img
            src="/Biblivium-logo.png"   // place your image inside the public folder
            alt="Biblivium Logo"
            style={{
              width: 24,
              height: 24,
              objectFit: "contain",
            }}
          />
          <span className="fw-semibold text-dark">Biblivium</span>
        </Navbar.Brand>

        {/* Mobile Toggle */}
        <Navbar.Toggle aria-controls="main-navbar" />

        {/* Nav Content */}
        <Navbar.Collapse id="main-navbar">
          {/* Center Links */}
          <Nav className="mx-auto text-center gap-lg-3 my-3 my-lg-0">
            {navLinks.map((link, index) => (
              <Nav.Link
                key={index}
                href={link.href}
                className="text-dark px-2 navlink-hover"
                data-aos="fade-up"
                data-aos-delay={300 + index * 100}
              >
                {link.label}
              </Nav.Link>
            ))}
          </Nav>

          {/* CTA Button */}
          <div
            className="d-flex justify-content-center"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            <Button
              href="/contact-us"
              className="px-4 py-2"
              style={{
                backgroundColor: "#1c1c1c",
                borderRadius: "16px",
                border: "none",
                boxShadow:
                  "inset 0 0 20px rgba(255,255,255,0.15), 0 10px 30px rgba(0,0,0,0.2)",
              }}
            >
              Contact Us
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>

      {/* Hover Styles */}
      <style>{`
        .navlink-hover {
          position: relative;
          transition: color 0.3s ease;
        }

        .navlink-hover::after {
          content: '';
          position: absolute;
          width: 0;
          height: 2px;
          display: block;
          margin-top: 4px;
          left: 0;
          background: #1c1c1c;
          transition: width 0.3s ease, left 0.3s ease;  
          -webkit-transition: width 0.3s ease, left 0.3s ease;
        }

        .navlink-hover:hover {
          color: #1c1c1c;
        }

        .navlink-hover:hover::after {
          width: 100%;
          left: 0;
        }
      `}</style>
    </Navbar>
  );
};
